// extracted by mini-css-extract-plugin
export default {"root":"TextOnly_root__2gmq_","description":"TextOnly_description__1avOB","title":"TextOnly_title__3uw42"};